import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import AuthService from './auth.service'

const useAuth = () => {
  const useRequestPasswordReset = () => {
    return useMutation({
      mutationFn: AuthService.requestPasswordReset,
      onSuccess: (res) => {
        //   toast.info(`Successfully Upload ${camelToWords(resource)}`)
      },
    })
  }

  const useResetPassword = () => {
    return useMutation({
      mutationFn: AuthService.resetPassword,
      onSuccess: (res) => {
        toast.info(`Successfully Reset Password`)
      },
    })
  }

  const useVerifyRecaptcha = () => {
    return useMutation({
      mutationFn: AuthService.verifyRecaptcha,
    })
  }

  return {
    useRequestPasswordReset,
    useResetPassword,
    useVerifyRecaptcha,
  }
}

export default useAuth
